import { useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';

export const useCampaignsRoutes = () => {
  const { url } = useRouteMatch();
  const [baseUrl] = url.split('/campaigns');

  return useMemo(
    () => ({
      index: `${baseUrl}/campaigns`,
      new: `${baseUrl}/campaigns/new`,
      edit: (campaignId: string) => `${baseUrl}/campaigns/${campaignId}/edit`,
      details: (campaignId: string) => `${baseUrl}/campaigns/${campaignId}`,
    }),
    [baseUrl],
  );
};
